/* lb-motion.js v2 — Love Bubble hardened motion engine.
   Contract:
   - Content is visible by default; the inline <head> gate adds html.lb-motion
     only when JS + IO exist and reduced-motion is off. This file cancels the
     gate's 1s fallback by setting window.lbMotionReady.
   - .lb-reveal elements get .is-revealed via IO (threshold .12), with a 1s
     force-reveal sweep for anything already on screen, a bfcache sweep, and
     a public 'lb:scan' event for tab panels / drawers that unhide content.
   - Legacy [data-lb-reveal] elements are folded into the same system.
   - One shared observer pauses ambient loops (.lb-ambient) off-screen.
   - html.lb-scrolled is set once after 40px for scroll-cue fades. */
(function () {
  'use strict';
  window.lbMotionReady = true;

  var docEl = document.documentElement;
  var motionOn = docEl.classList.contains('lb-motion');

  /* ---- fold legacy attribute API into the class API ---- */
  document.querySelectorAll('[data-lb-reveal]').forEach(function (el) {
    el.classList.add('lb-reveal');
  });
  document.querySelectorAll('[data-lb-reveal-group]').forEach(function (el) {
    el.classList.add('lb-stagger');
  });

  var els = document.querySelectorAll('.lb-reveal');

  var io = null;
  function reveal(el) {
    /* 'is-revealed' = v2 system; 'lb-in' = legacy per-section CSS keyed on it */
    el.classList.add('is-revealed');
    el.classList.add('lb-in');
    if (io) io.unobserve(el);
  }

  if (motionOn && els.length && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) reveal(e.target); });
    }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });
    els.forEach(function (el) { io.observe(el); });
  } else {
    /* No motion context: make sure nothing can be hidden */
    els.forEach(function (el) { el.classList.add('is-revealed'); });
  }

  function sweep(root) {
    var scope = (root && root.querySelectorAll) ? root : document;
    scope.querySelectorAll('.lb-reveal:not(.is-revealed)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0 && r.width) reveal(el);
    });
  }
  setTimeout(sweep, 1000);
  window.addEventListener('pageshow', function (e) { if (e.persisted) sweep(); });
  document.addEventListener('lb:scan', function (e) {
    var t = (e.target && e.target.querySelectorAll) ? e.target : document;
    /* small delay so display changes settle before measuring */
    setTimeout(function () { sweep(t); }, 30);
  });
  /* theme editor: re-rendered sections insert fresh (unobserved) nodes */
  document.addEventListener('shopify:section:load', function (e) {
    var t = (e.target && e.target.querySelectorAll) ? e.target : document;
    t.querySelectorAll('[data-lb-reveal]').forEach(function (el) { el.classList.add('lb-reveal'); });
    t.querySelectorAll('[data-lb-reveal-group]').forEach(function (el) { el.classList.add('lb-stagger'); });
    t.querySelectorAll('.lb-reveal:not(.is-revealed)').forEach(function (el) {
      if (io) { io.observe(el); } else { el.classList.add('is-revealed'); }
    });
    setTimeout(function () { sweep(t); }, 30);
  });

  /* ---- ambient loop management: pause everything off-screen ---- */
  var ambients = document.querySelectorAll('.lb-ambient');
  if (ambients.length && 'IntersectionObserver' in window) {
    var aio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        e.target.classList.toggle('is-offscreen', !e.isIntersecting);
      });
    }, { threshold: 0 });
    ambients.forEach(function (el) { aio.observe(el); });
  }
  document.addEventListener('visibilitychange', function () {
    ambients.forEach(function (el) {
      if (document.hidden) { el.classList.add('is-offscreen'); return; }
      var r = el.getBoundingClientRect();
      el.classList.toggle('is-offscreen', !(r.bottom > 0 && r.top < window.innerHeight));
    });
  });

  /* ---- scroll flag for cue fades (set once, listener removed) ---- */
  function onScroll() {
    if (window.scrollY > 40) {
      docEl.classList.add('lb-scrolled');
      window.removeEventListener('scroll', onScroll);
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();